import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  .bg-block-1 {
    background: #fff0e2;
    background-image: linear-gradient(165deg, #fff0e2 20%, #ffffff 58%);
  }

  .carousel-container {
    padding-bottom: 50px;
    /* > .desktop {
    }
    > .mobile {
      display: none;
    } */
  }

  .our-service-container {
    padding: 10px 100px 50px 100px;
  }

  .why-us-container {
    padding: 70px 0 20px 0;
  }

  .bg-block-2 {
    position: relative;
    z-index: 2;
  }

  .promotion-container {
    padding: 60px 0 50px 0;
  }

  .review-container {
    > .desktop {
      padding: 70px 0 30px 0;
    }
    > .mobile {
      display: none;
    }
  }

  .work-container {
    padding-top: 80px;
    padding-bottom: 60px;
  }

  .portfolio-container {
    padding-top: 100px;
    position: relative;
    z-index: 2;
    background-color: #ffffff;
  }

  .customer-container {
    padding: 80px 0;
    position: relative;
    z-index: 2;
  }

  .background-block {
    background-image: linear-gradient(179deg, #ffffff 10%, #ffdaba 101%);
    .business-container {
      padding: 40px 0 64px 0;
    }

    .invite-container {
      > .desktop {
        padding: 60px 0 80px 0;
      }
      > .mobile {
        display: none;
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .our-service-container {
      padding: 10px 50px 50px 50px;
    }

    .customer-container {
      padding: 60px 0;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .carousel-container {
      padding-bottom: 20px;
    }

    .our-service-container {
      padding: 20px 0 50px 0;
    }

    .work-container {
      padding-top: 70px;
      padding-bottom: 40px;
    }

    .portfolio-container {
      background-color: #eae7e4;
      padding-top: 20px;
    }

    .customer-container {
      background: #fff9f4;
      padding: 50px 0;
    }

    .background-block {
      background: #fff9f4;
      background-image: linear-gradient(to bottom, #ffffff 9%, #ffdaba 102%);
      .business-container {
        padding: 60px 0 100px 0;
      }
      .invite-container {
        > .desktop {
          display: none;
        }
        > .mobile {
          display: block;
          background-image: linear-gradient(#ffffff, #ffffff, #ffe4ce);
          padding: 30px 0 60px 0;
        }
      }
    }
  }
`
